export function instructorFilter() {
  const select = document.getElementById("js-instructor-filter");
  const list = document.getElementById("js-instructor-list");
  if (!select || !list) return;

  const items = list.querySelectorAll("[data-area]");

  let noResultsEl = list.querySelector(".js-no-results");
  if (!noResultsEl) {
    noResultsEl = document.createElement("li");
    noResultsEl.className = "js-no-results";
    noResultsEl.textContent = "該当する講師が見つかりませんでした。";
    noResultsEl.hidden = true;
    list.appendChild(noResultsEl);
  }

  select.addEventListener("change", () => {
    const value = select.value;
    let visibleCount = 0;

    items.forEach((item) => {
      if (!value || item.dataset.area.split(" ").includes(value)) {
        item.hidden = false;
        visibleCount++;
      } else {
        item.hidden = true;
      }
    });

    noResultsEl.hidden = visibleCount > 0;
  });
}
